module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/LA-Juvie-Yard2_BW-p-1600-005b2d5f54ae25d5a6642cd894ce8cfe.jpg";